import { twMerge } from "tailwind-merge";
import { Badge } from "../badge/Badge";
import { getStockDisplay } from "./getStockDisplay";

export function StockIndicator({
  stock: initStock,
  type = "full",
  showStock = true,
  canBackorder,
}: {
  stock: number;
  type?: "full" | "short" | "minimal";
  showStock?: boolean;
  canBackorder?: boolean;
}) {
  const { stockQuantity, textColor, backgroundColor } = getStockDisplay({
    initStock,
    type,
    showStock,
    canBackorder,
  });

  return (
    <Badge
      className={twMerge(
        textColor,
        backgroundColor,
        type === "minimal" && "px-1",
      )}
      icon={"CIRCLE"}
      iconSize={0.4}
    >
      {type !== "minimal" ? stockQuantity : undefined}
    </Badge>
  );
}
